module.exports = __webpack_public_path__ + "resources/img/img_intro_certi2.facb084adc56aae55f946b21ab0413ac.png";